var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modelError)?_c('div',{staticClass:"con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"},[_c('span',{staticClass:"span-text-validation",domProps:{"textContent":_vm._s(_vm.modelError ? _vm.modelError[0] : null)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }